import {inject, Injectable, signal} from '@angular/core';
import {collection, Firestore, getDocs, QuerySnapshot} from 'firebase/firestore';
import {FirebaseInitService} from '../shared/firebase-init.service';
import {Badge, badgeConverter} from '@models';

@Injectable()
export class BadgeService {
	public readonly badges = signal<Badge[]>([]);
	private readonly firebaseInit = inject(FirebaseInitService);
	private hasLoaded = false;
	
	// Lazy getter for Firebase Firestore to avoid initialization errors in SSR
	private get firestore(): Firestore {
		return this.firebaseInit.firestore;
	}
	
	private get collection() {
		return collection(this.firestore, 'badges');
	}

	getBadgeList() {
		const badgeList: Badge[] = [];
		this.badges.set(badgeList);
		if (this.hasLoaded) {
			return this.badges.asReadonly();
		}
		this.hasLoaded = true;
		getDocs(this.collection.withConverter(badgeConverter)).then((querySnapshot: QuerySnapshot<Badge>) => {
			querySnapshot.forEach((docSnapshot) => {
				const badge = docSnapshot.data();
				badgeList.push(badge);
			});
			this.badges.set(badgeList);
		});
		return this.badges.asReadonly();
	}
}
